// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__10XRy","inputWrap":"Table_inputWrap__3Qbnt","col":"Table_col__dxzef","bmiTooltip":"Table_bmiTooltip__2Y7XC"};